<!-- 项目文件 -->
<template>
<div>
    <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
    <div class="w1200 mauto mt30 mb50 bgfff overflow">
            <div class="textc mt20 mb20">
                <p class="fs36 c333 disinblock posre">
                    <span class="border-bottom1">
                        学车指南
                    </span>
                </p> 
            </div>
            <div class="w100p overhidden">
                <ul class="disinblock w100p ml-10 demo ">
                    <li  @click="open(index,item.title,item.detail)" v-for="(item,index) in guideList" :key="index" class="floatl mt20 disinblock w30p bg111 ml36 pl10 box pt30 pb20 pl20 cursor">
                        <div class="overflow alit posre">
                            <span class="fs40 ccccc floatl fbold">
                                0{{index+1}}
                            </span>
                            <span class="fs14 cfff floatr bg1f8 posab right0 toleft h25 lh25 w45 textc">
                                科二
                            </span>
                        </div>
                        <h2 class="fs18 fbold c333 pt15 pb15">
                            {{item.title}}
                        </h2>
                        <p class="fs14 c666" v-for="(v,i) in item.detail.slice(0,2)" :key="i">
                           {{v}}
                        </p>
                    </li>

                    
                </ul>
            </div>
    </div>

            <div class="posfix bgrg w100p h100p zindex999 pl10 pr10 overflow top0 left0  " v-show="mask==1">
                <div class="posab left30p top30p bgfff w30p pt20 pb20 pl40 pr40 bradius8 maxh300" >
                    <p class=" fbold fs20 c1f8 textc"> {{Tit}} </p>
                    <span @click="choose()" class="disinblock posab top0 right11 fs26 c333 cursor"> × </span>
                    <div class="maxh250 gundong"  style="overflow-y: auto;">
                        <div class="pt20 pb20 textc" v-for="(item,index) in detailList" :key="index">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>
    <Footer></Footer>
</div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {

                mask: 0,
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                guideList: [{
                    title: '倒车入库',
                    detail: [
                        '倒库出库并不难，系带挂挡左灯闪，',
                        '踩住离合放手刹，慢抬离合起步缓。',
                        '看好右线调车身，左镜竖缝沿右线。',
                        '前边横线齐肩停，挂上倒档离合松。',
                        '左镜盖住横线角，向右打死方向好。',
                        '看准左镜等库线，夹角30回一圈，',
                        '等到车与线平行，回正方向整两圈，',
                        '左镜盖住库前角，踩住离合和刹车。',
                        '挂上一档要出库，车头触线左打足。',
                        '车头盖线车停好，方向不动把车倒。',
                        '看准右镜等库线，夹角30回一圈，',
                        '等到车与线平行，回正方向整两圈，',
                        '左镜盖住库前角，踩住离合和刹车。',
                        '挂上一档要出库，车头触线右打足。',
                        '车头盖线车停好，调正车身本领高',
                    ]
                }, {
                    title: '直角拐弯',
                    detail: [
                        '弯前一档车速慢， 摆正车身是关键。',
                        '左边三十公分好， 不能压线要记牢。',
                        ' 车头接近突起点， 左打方向莫迟延。',
                        ' 后视镜中看后轮， 打回方向别慌乱。 ',
                    ]
                }, {
                    title: '侧方停车',
                    detail: [
                        '侧方停车在右边，中轴去瞄右边线。',
                        '直行慢过右边角，倒车要把右镜看。',
                        '盖过右角右打死，前看左线到中间。',
                        '左打方向整两圈，再把左后镜子看。',
                        '后轮压线右打死，等到车身平库线。',
                        '停稳车身挂一档，不要忘记左灯闪。',
                        '慢抬离合看左角，触到左线回一圈。',
                        '线到中间回两圈，车身出库正车完。'
                    ]
                }, {
                    title: '上坡起步',
                    detail: [
                        '上坡起步要放松，右线对准雨刷中。',
                        '中轴对准白线后，调正车身看右镜。',
                        '小于三十公分好，缓缓起步看左镜。',
                        '左镜压线踩刹车，拉好手刹别熄火。',
                        '踩住脚刹放手刹; 抬起左手把灯打;',
                        ' 轻轻抬起离合器; 听声变了放脚刹。',
                        '车速缓缓向前走，上坡起步完成啦。'
                    ]
                }, {
                    title: '曲线行驶',
                    detail: [
                        ' 车头先把曲线进，左棱右线紧瞄准。',
                        '左棱紧贴右线走，要触左线回正身。',
                        ' 左线移到车头中，一圈方向要回稳。',
                        '右棱快要触左线，半圈方向要瞄准'
                    ]
                }],
                detailList: [],
                Tit: ''
            };
        },
        components: {
            Header,
            Footer,
        },
        methods: {
            open(id, tit, detail) {
                this.mask = 1;
                this.Tit = tit;
                this.detailList = detail;

                $('body').css("overflow", "hidden")
            },
            choose() {
                this.mask = 0;
                $('body').css("overflow", "auto")
            },

        },
        created() {
            this.cityName = this.$store.state.cityName;

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bg111 {
        background-image: url('../../public/img/img71.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
</style>